import Vue from 'vue'
import {
	Vuetify,
	VApp,
	VNavigationDrawer,
	VFooter,
	VList,
	VBtn,
	VIcon,
	VGrid,
	VToolbar,
	VDataTable,
	VProgressLinear,
	transitions,
	VMenu,
	VTextField,
	VForm,
	VSelect,
	VDialog,
	VCard,
	VTreeview,
	VSheet,
	VSnackbar,
	VDatePicker,
	VTextarea,
	VExpansionPanel,
	VImg,
	VTabs,
	VCombobox,
	VChip,
	VBottomSheet,
	VBtnToggle,
	VTooltip,
	VDivider,
	VSlider,
	VCheckbox,
	VHover,
	VItemGroup,
	VBadge,
	VSpeedDial,
	VBreadcrumbs,
	VPagination,
	VSwitch,
	VRadioGroup,
	VStepper,
	VTimePicker,
	VAutocomplete,
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
	components: {
		VApp,
		VNavigationDrawer,
		VFooter,
		VList,
		VBtn,
		VIcon,
		VGrid,
		VToolbar,
		VDataTable,
		VProgressLinear,
		transitions,
		VMenu,
		VTextField,
		VForm,
		VSelect,
		VDialog,
		VCard,
		VTreeview,
		VSheet,
		VSnackbar,
		VDatePicker,
		VTextarea,
		VExpansionPanel,
		VImg,
		VTabs,
		VCombobox,
		VChip,
		VBottomSheet,
		VBtnToggle,
		VTooltip,
		VDivider,
		VSlider,
		VCheckbox,
		VHover,
		VItemGroup,
		VBadge,
		VSpeedDial,
		VBreadcrumbs,
		VPagination,
		VSwitch,
		VRadioGroup,
		VStepper,
		VTimePicker,
		VAutocomplete
	},
	theme: {
		primary: '#1976D2',
		secondary: '#424242',
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FFC107'
	},
	iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
});
/*
// @ts-ignore
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
// don't forget to import styles
import "tiptap-vuetify/dist/main.css";

Vue.use(TiptapVuetifyPlugin, {
	// optional, default to 'md' (default vuetify icons before v2.0.0)
	iconsGroup: "md"
});*/